import axios from 'axios';
import { useInterceptor } from './apiUtils';
import { API_URL } from '../constants';

useInterceptor(axios);

export function newPayment(idx) {
	return axios({
		method: 'get',
		url: `${API_URL}/payments/new?idx=${idx}`
	});
}

export function getTransactionType(idx) {
	return axios({
		method: 'get',
		url: `${API_URL}/payments/transaction_type`,
		params: { idx }
	});
}

/** Available payment methods for a listing/charge currency pair. */
export function getPaymentMethods({ listingCurrency, paymentCurrency } = {}) {
	return axios({
		method: 'get',
		url: `${API_URL}/payments/payment_methods`,
		params: {
			listing_currency: listingCurrency,
			payment_currency: paymentCurrency,
		},
	});
}

/** Unified payment initiation — gateway: khalti | esewa | card */
export function initiatePayment(params) {
	const data = {
		gateway: params.gateway,
		product_identity: params.productIdentity,
		amount: params.amount,
		product_name: params.productName,
		customer_name: params.customerName,
		customer_email: params.customerEmail,
		customer_phone: params.customerPhone,
	};
	if (params.payment_currency) data.payment_currency = params.payment_currency;
	return axios({
		method: 'post',
		url: `${API_URL}/payments/initiate_payment.json`,
		data,
	});
}

export function payWithKhalti(payload) {
	return axios({
		method: 'post',
		url: `${API_URL}/payments/pay_with_khalti.json`,
		data: payload
	});
}

/** Public: current USD to NPR fixed rate for checkout display. */
export function getCurrencyRate() {
	return axios({ method: 'get', url: `${API_URL}/currency_rate` });
}

// Backward compatible Khalti initiate
export function initiateKhaltiPayment(params) {
	return initiatePayment({ ...params, gateway: 'khalti' });
}

/** Submit a gateway HTML form (eSewa, HBL card) in the current window. */
export function submitPaymentForm({ action, fields }) {
	const form = document.createElement('form');
	form.setAttribute('method', 'POST');
	form.setAttribute('action', action);
	Object.entries(fields || {}).forEach(([key, value]) => {
		const hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', value);
		form.appendChild(hiddenField);
	});
	document.body.appendChild(form);
	form.submit();
}
